test.todo('some test to be written in the future');

// Could not make test for this component because it requires
// a coffee script and jest doesn't know what do do with it.
// Needs extra configuration.
